import { Component, Inject, Input, OnInit, forwardRef } from '@angular/core';
import { NgbActiveModal }  from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ConfirmService }       from '../messages/confirm/confirm.service';
import { MessagesService }      from '../messages/messages.service';
import { Table }                from '../table/types/table';
import { VendorFactoryService } from './vendor-factory.service';
import { RemoveComponent }      from '../table/cell-components/actions/remove.component';

@Component({
  selector: 'wor-vendor-linked-vendors',
  template: `
    <div class="modal-header state clearfix bg-info title">
      <h1>Linked Vendors</h1>
    </div>
    <div class="modal-body clearfix">
      <wor-table
        [(data)]="links"
        [settings]="tableSettings">
      </wor-table>
    </div>
    <div class="modal-footer d-flex">
      <button type="button" class="btn btn-default m-left-auto"
        (click)="modal.dismiss()">
        Close
      </button>
    </div>
  `
})
export class VendorLinkedVendorsComponent implements OnInit {
  @Input() links: any[] = [];

  tableSettings: Table;

  constructor (
    public  modal               : NgbActiveModal,
    private confirmService      : ConfirmService,
    private messagesService     : MessagesService,
    private translateService    : TranslateService,
    @Inject(forwardRef(() => VendorFactoryService)) private vendorFactoryService: VendorFactoryService
  ) {}

  ngOnInit (): void {
    this.tableSettings = {
      columns: [
        {
          component: {
            bindings: {
              outputs: {
                onRemoveClick: event => this.removeItem(event)
              }
            },
            enabled: true,
            factory: RemoveComponent
          },
          sortable: false
        },
        {
          classes: 'text-left',
          field  : 'store_name',
          header : {
            text: 'Store Name'
          }
        },
        {
          classes: 'text-left',
          field  : 'company_name',
          header : {
            text: 'Company Name'
          }
        }
      ],
      empty: {
        text: this.translateService.instant('GENERAL_SPACE.STATUS.NO_RESULTS')
      },
      pagination: {
        enabled: false
      },
      sorting: {
        enabled: false
      },
      static: true
    };
  }

  removeItem (row: any): void {
    this.confirmService.generic('Are you sure you want to delete this linked vendor?').then(() => {
      return this.vendorFactoryService.deleteLinkedVendor(row);
    }).then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.DELETED'), 'success');
      this.modal.close();
    }).catch(err => {
      this.messagesService.error(err);
    });
  }
}
